module.exports = __webpack_public_path__ + "img/photo-22.9663d3c6.jpg";